// @ts-nocheck
import { useState, useEffect } from 'react';
import { supabase } from "@/lib/supabase";

interface Sport {
  id: string;
  name: string;
  gender?: string;
  active?: boolean;
}

export function useSports() {
  const [sports, setSports] = useState<Sport[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSports = async () => {
      try {
        setIsLoading(true);
        const { data, error } = await supabase
          .from('sports')
          .select('*')
          .eq('is_active', true)
          .order('name', { ascending: true });

        if (error) throw error;
        
        setSports(data || []);
        setError(null);
      } catch (err: any) {
        console.error('Error fetching sports:', err);
        setError(err.message);
        setSports([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSports();
  }, []);

  return { sports, isLoading, error };
}
